import React, { useContext } from "react";
import footerlogo from "../photos/logo.png";
import "./footer.css";
import { FaInstagram } from "react-icons/fa";
import { SlSocialFacebook } from "react-icons/sl";
import { HiOutlineMail } from "react-icons/hi";
import { TbPhoneCall } from "react-icons/tb";
import { NavLink } from "react-router-dom";
import { LanguageContext } from "../settings/LanguageContext";
import { PiTiktokLogo } from "react-icons/pi";


const Footer = () => {
  const { lang } = useContext(LanguageContext);

  return (
    <div className="main-footer">
      <div className="footer-container">
        <NavLink to="/" className={({ isActive }) => (isActive ? "active" : "")}>
          <div className="footer-logo">
            <img src={footerlogo} alt="company logo" />
          </div>
        </NavLink>

        <div className="foooter-menu">
          <h4 className="footer-title">
            {lang === "EN" ? "Company" : "Компания"}
          </h4>
          <ul className="footer-companymenu">
            <li>
              <NavLink to="/tours" className={({ isActive }) => (isActive ? "active" : "")}>
                {lang === "EN" ? "Tours" : "Туры"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/gallery" className={({ isActive }) => (isActive ? "active" : "")}>
                {lang === "EN" ? "Gallery" : "Галерея"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => (isActive ? "active" : "")}>
                {lang === "EN" ? "About Us" : "О нас"}
              </NavLink>
            </li>
            <li>
              <NavLink to="/contactus" className={({ isActive }) => (isActive ? "active" : "")}>
                {lang === "EN" ? "Contact Us" : "Контакты"}
              </NavLink>
            </li>
          </ul>
        </div>

        <div className="footer-contactinfo">
          <h4 className="footer-title">
            {lang === "EN" ? "Contact Information" : "Контактная информация"}
          </h4>
          <div className="footer-email">
            <HiOutlineMail size={24} /> info@memorymakerarmenia.com
          </div>
          <div className="footer-phone">
            <TbPhoneCall size={24} /> (+374)93106810
          </div>
        </div>

        <div className="footer-followus">
          <h4 className="footer-title">
            {lang === "EN" ? "Follow Us" : "Подписывайтесь"}
          </h4>
          <a href="https://www.facebook.com/ToursinArmeniaTourGuideinArmenia" target="_blank" rel="noopener noreferrer">
            <button className="footer-icons">
              <SlSocialFacebook className="footer-icon" />
            </button>
          </a>
          <a href="https://www.instagram.com/memory_maker_travel_armenia/" target="_blank" rel="noopener noreferrer">
            <button className="footer-icons" id="leftplease">
              <FaInstagram className="footer-icon" />
            </button>
          </a>

          <a href="https://www.tiktok.com/@memory_maker_armenia?_r=1&_t=ZS-93yW6Hm1EhD/" target="_blank" rel="noopener noreferrer">
            <button className="footer-icons" id="leftplease">
              <PiTiktokLogo className="footer-icon" />
            </button>
          </a>

        </div>
      </div>

      <div className="footerend">
        {lang === "EN"
          ? "2026 Travel Agency. All rights reserved"
          : "2026 Туристическое агентство. Все права защищены"}
      </div>
    </div>
  );
};

export default Footer;
